import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dashWhenEmpty'
})
export class DashWhenEmptyPipe implements PipeTransform {

  constructor() {}

  transform(value: string): string {
    return (value !== null && value !== '') ? value : '-';
  }

}
